<div>
    <input maxlength="21" type="text" class="hideInputPosition"
    id="scanner_id" [(ngModel)]="valueTemp" tabindex="-1"
    (keydown.enter)="setValueInField()" (blur)="removeAllFocus()"
	#floatinput inputmode="none">
</div>
